<template>
  <div class="page-dictionary-config">
    <crm-panel :title="'团队字典配置'">
      <div class="page-buttons">
        <crm-button
          v-if="auth.teamCategoryAdd && auth.teamCategoryAdd.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="isAddDialogVisible = true"
        >
        </crm-button>
      </div>
      <div class="mt20">
        <el-form ref="form" :inline="true">
          <el-form-item label="">
            <el-select
              clearable
              v-model="search.categoryId"
              placeholder="字典名称"
            >
              <el-option
                v-for="item in categoryList.data"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
              <el-option
                v-if="
                  allCategoryList.totalCount > categoryList.pageSize &&
                    allCategoryList.totalPages > categoryList.pageNumber
                "
                label="点击加载更多"
                value="点击加载更多"
                :disabled="true"
                style="cursor:pointer;"
              >
                <span @click="handleMoreCategoryList()">点击加载更多</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select clearable v-model="search.teamId" placeholder="二级团队">
              <el-option
                v-for="item in secondTeamList.data"
                :label="item.name"
                :value="item.teamId"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="teamConfigList.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          label="字典名称"
          align="center"
          width="160"
          prop="categoryName"
        >
        </el-table-column>
        <el-table-column
          label="二级团队"
          align="center"
          width="160"
          prop="teamName"
        >
        </el-table-column>
        <el-table-column
          prop="dictionaryName"
          align="center"
          label="字典项名称"
        >
        </el-table-column>
        <el-table-column align="center" width="120" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="handleUpdate(scope)"
              type="text"
              size="small"
              v-if="
                auth.teamCategoryUpdate && auth.teamCategoryUpdate.toggleStatus
              "
              >编辑</el-button
            >
            <el-button
              @click="handleDelete(scope)"
              type="text"
              size="small"
              v-if="
                auth.teamCategoryDelete && auth.teamCategoryDelete.toggleStatus
              "
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="teamConfigList.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 新增字典配置弹窗 -->
    <add-team-config
      v-if="isAddDialogVisible"
      @close="isAddDialogVisible = false"
      @success="handleRefreshConfigList()"
    >
    </add-team-config>

    <!-- 编辑字典配置 -->
    <update-team-config
      v-if="isUpdateDialogVisible"
      :id="detailId"
      @close="isUpdateDialogVisible = false"
      @success="handleRefreshConfigList()"
    >
    </update-team-config>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AddTeamConfig from '~component/business/backstage/AddTeamConfig.vue';
import UpdateTeamConfig from '~component/business/backstage/UpdateTeamConfig.vue';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';

export default {
  components: {
    AddTeamConfig,
    UpdateTeamConfig,
    crmPanel,
    crmButton,
  },
  data() {
    return {
      loading: false,
      search: {
        categoryId: '',
        teamId: '',
      },
      page: {
        pageSize: 10,
        pageNumber: 1,
      },
      categoryList: {
        data: [],
        pageNumber: 1,
        pageSize: 100,
      },
      isAddDialogVisible: false,
      isUpdateDialogVisible: false,
      detailId: '',
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      backstageMenu: 'authority/backstageMenu',
      teamConfigList: 'backstage/teamConfigList',
      secondTeamList: 'backstage/secondTeamList',
      allCategoryList: 'backstage/allCategoryList',
    }),
  },
  watch: {
    'search.categoryId': {
      handler: 'handleSearch',
    },
    'search.teamId': {
      handler: 'handleSearch',
    },
  },
  created() {
    this.getTeamConfigList(this.page);
    this.getSecondTeamList();
    this.handleGetAllCategoryList();
  },
  methods: {
    ...mapActions({
      getTeamConfigList: 'backstage/getTeamConfigList',
      deleteTeamConfig: 'backstage/deleteTeamConfig',
      getSecondTeamList: 'backstage/getSecondTeamList',
      getAllCategoryList: 'backstage/getAllCategoryList',
    }),
    handleSearch() {
      this.getTeamConfigList({
        ...this.page,
        ...this.search,
      });
    },
    handleGetAllCategoryList() {
      return new Promise((resolve, reject) => {
        this.getAllCategoryList({
          pageNumber: this.categoryList.pageNumber,
          pageSize: this.categoryList.pageSize,
        })
          .then(() => {
            if (this.categoryList.pageNumber === 1) {
              this.categoryList.data = [];
            }
            this.allCategoryList.results.forEach((item) => {
              this.categoryList.data.push(item);
            });
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleMoreCategoryList() {
      this.categoryList.pageNumber += 1;
      this.handleGetAllCategoryList();
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.pageNumber = 1;
      this.handleSearch();
    },
    handlePageChange(index) {
      this.page.pageNumber = index;
      this.handleSearch();
    },
    handleRefreshConfigList() {
      this.handleSearch();
    },
    handleUpdate(scope) {
      this.detailId = scope.row.id;
      this.isUpdateDialogVisible = true;
    },
    handleDelete(scope) {
      this.$confirm('确认删除该条字典配置？').then(() => {
        this.deleteTeamConfig({
          id: scope.row.id,
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
          });
          this.handleSearch();
        });
      });
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/var.less';

.page-dictionary-config {
  display: flex;
  flex: 1;
  width: 100%;
  .dialog-body {
    padding-right: 40px;
  }
}
</style>
